const VALIDATION_ERROR = /Validation failed:/

const serializeErrorMessages = ({ graphQLErrors, networkError }) => {
  if (networkError) {
    return 'An error has occurred. Please try again.'
  }

  const validationErrors = graphQLErrors
    .filter(({ message }) => VALIDATION_ERROR.test(message))
    .map(({ message }) => message.replace(VALIDATION_ERROR, '').trim())

  return validationErrors.length ? validationErrors : 'An error has occurred.'
}

export default serializeErrorMessages



// WEBPACK FOOTER //
// ./src/utils/serializeErrorMessages.js